import { AllocationCategory, AllocationSubCategory } from "../types";

// Meta types based on category
export const getMetaTypes = (category: AllocationCategory) => {
  switch (category) {
    case AllocationCategory.VEHICLE:
      return ["DRIVER", "CLEANER", "LADY"];
    case AllocationCategory.RESOURCE:
      return ["VEHICLE", "DRIVER", "CLEANER", "LADY", "AREA_MANAGER", "CLUSTER_LEADER"];
    default:
      return ["VEHICLE", "DRIVER", "CLEANER", "LADY"];
  }
};

export const getSubCategories = (category: AllocationCategory) => {
  switch (category) {
    case AllocationCategory.VEHICLE:
      return ["BUS", "TRUCK"];
    case AllocationCategory.RESOURCE:
      return ["DRIVER", "CLEANER", "LADY", "AREA_MANAGER", "CLUSTER_LEADER"];
    default:
      return [];
  }
};
